module.exports = __webpack_public_path__ + "static/media/insurance-eo-640.54513d27.jpg";